import { logger } from '@lichtblick/logger';
import { useTracker } from '@lichtblick/tracker';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export type TemplateTrackerProps = {
  contentGroup?: string;
  contentGroup2?: string;
  contentGroup3?: string;
  pageArea: string;
  pageTitle: string;
  pageType: string;
};

export const useTemplateTracker = ({
  contentGroup,
  contentGroup2,
  contentGroup3,
  pageArea,
  pageTitle,
  pageType,
}: TemplateTrackerProps) => {
  const _pathname = usePathname();
  const { trackPageMetaEvent, trackVirtPathEvent } = useTracker();

  useEffect(() => {
    trackVirtPathEvent({
      virtPagePath: window.location.pathname,
      virtPageTitle: pageTitle,
    });
  }, [trackVirtPathEvent, pageTitle]);

  useEffect(() => {
    logger.log(`Page View: ${window.location.pathname}`);
  }, []);

  useEffect(() => {
    trackPageMetaEvent({
      contentGroup,
      contentGroup2,
      contentGroup3,
      pageArea,
      pageType,
    });
  }, [contentGroup, contentGroup2, contentGroup3, pageArea, pageType, trackPageMetaEvent]);
};
